import HelpError from 'components/Form/HelpError';
import useFormError from 'hooks/useFormErrors';
import {FC} from 'react';
import {useFormContext} from 'react-hook-form';
import {t} from 'ttag';
import {isTaxTypeZero, TaxCombination} from 'utils/tax';

import {Deserializer, ModalFormField, prepareData, UNSELECTED} from '../utils';

interface Props {
    checkDuplicate?: (newTaxCombination: TaxCombination) => boolean;
}

const DuplicateErrorMessage: FC<Props> = ({checkDuplicate}) => {
    const form = useFormContext<ModalFormField>();
    const error = useFormError('checkDuplicate');

    form.register('checkDuplicate', {
        validate: () => {
            const formData = form.getValues();

            if (!checkDuplicate) {
                return undefined;
            }

            if (formData.taxTypeRadio === UNSELECTED) {
                return undefined;
            }

            const taxType = Deserializer.taxType(formData.taxTypeRadio);
            const isTaxTypeZeroValue = isTaxTypeZero(taxType);

            if (
                isTaxTypeZeroValue ||
                (!isTaxTypeZeroValue &&
                    formData.taxRateRadio !== UNSELECTED &&
                    formData.isTaxInclusiveRadio !== UNSELECTED)
            ) {
                const newTaxCombination = prepareData(formData);

                if (checkDuplicate(newTaxCombination)) {
                    return t`Same Tax Setting already exists.`;
                }
            }

            return undefined;
        },
    });

    return <HelpError className="h-5" error={error} label={error?.message} />;
};

export default DuplicateErrorMessage;
